export * from './cookie-law.component';
export * from './cookie-law.module';
